const defaultState = {
    isLimited: false,
    phoneValidationCheck:false
};

const customerInformationsReducer = (state = {...defaultState}, action) => {
  switch (action.type) {
    case "RESET_CUSTOMER_INFO":
      return {
        ...defaultState
      }
    case "UPDATE_CUSTOMER_INFO":
      return {
        ...state,
        ...action.payload
      };
    default:
      return { ...state };
  }
};

export default customerInformationsReducer;
